import { render } from "./_video.vue?vue&type=template&id=33dee93c&scoped=true"
import script from "./_video.vue?vue&type=script&lang=js"
export * from "./_video.vue?vue&type=script&lang=js"

import "./_video.vue?vue&type=style&index=0&id=33dee93c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33dee93c"]])

export default __exports__